import React, { useEffect, useState } from 'react';
import './Gallery.css';

const PASSWORD = 'Emeka';

const Gallery = () => {
  const [inputPassword, setInputPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // ⏱️ TIMER
  useEffect(() => {
    let timer;

    if (isAuthenticated) {
      timer = setTimeout(() => {
        handleLogout();
      }, 5 * 60 * 100); // 5 minutes
    }

    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  useEffect(() => {
    const savedAuth = localStorage.getItem('galleryAuth');
    if (savedAuth === 'true') setIsAuthenticated(true);
  }, []);

  const handleSubmit = () => {
    if (inputPassword.trim() === PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('galleryAuth', 'true');
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('galleryAuth');
    setIsAuthenticated(false);
    setInputPassword('');
    setError('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSubmit();
  };

  // 🔒 LOGIN SCREEN
  if (!isAuthenticated) {
    return (
      <div className="gallery-page">
        <div className="gallery-overlay">
          <h1 className="gallery-title">Private Access</h1>
          <p className="gallery-subtitle">Enter password to continue</p>

          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              className="gallery-input"
              value={inputPassword}
              onChange={(e) => setInputPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter password"
            />
            <span
              className="toggle-eye"
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? '🙈' : '👁'}
            </span>
          </div>

          <button className="gallery-button" onClick={handleSubmit}>
            Enter
          </button>

          {error && <p className="gallery-error">{error}</p>}
        </div>
      </div>
    );
  }

  // 🔥 LINKS PAGE (AFTER LOGIN)
  return (
    <div className="links-page">

      <div className="links-header">
        <h1>Private Access</h1>
        <button onClick={handleLogout}>Logout</button>
      </div>

      <div className="links-grid">

        {/* PHOTO LINK */}
        <a
          href="https://maps.google.com"
          target="_blank"
          rel="noopener noreferrer"
          className="link-card"
        >
          <div
            className="link-bg"
            style={{
              backgroundImage: `url('https://images.unsplash.com/photo-1515378791036-0648a3ef77b2')`
            }}
          />
          <div className="link-overlay">
            <h2>View Photos</h2>
          </div>
        </a>

        {/* DECRYPTION LINK */}
        <a
  href="https://event-package-website-perform.streamlit.app"
  className="link-card"
>
  <div
    className="link-bg"
    style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1550751827-4bd374c3f58b')`
    }}
  />
  <div className="link-overlay">
    <h2>Encrypt & Decrypt Messages</h2>
  </div>
</a>

{/* PUSHUP LINK */}
<a
  href="https://pushup-pushhard.streamlit.app"
  target="_blank"
  rel="noopener noreferrer"
  className="link-card"
>
  <div
    className="link-bg"
    style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1598971639058-fab3c3109a00')`
    }}
  />
  <div className="link-overlay">
    <h2>Pushup-PushHard</h2>
  </div>
</a>

      </div>
    </div>
  );
};



export default Gallery;